import React from 'react';
import { FormattedMessage } from 'react-intl';
import Prism from 'prismjs';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { createYesElfIntegrationScript } from 'yeself-common/utils/IntegrationUtils';
import { ApplicationId } from 'yeself-common/typings/application/Application';
import { LayerId, LayerType } from 'yeself-common/typings/guide/LayerCommon';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

import { selectIsIfcNamespaceEnabled } from 'Console/data/applicationDetail/settings/SettingsSelector';

import 'prismjs/themes/prism.css';

type GuidePluginConfigurationProps = {
    applicationId: ApplicationId;
    guideId: LayerId;
    guideType: LayerType;
};

const GuidePluginConfiguration = ({
    guideId,
    guideType,
    applicationId,
}: GuidePluginConfigurationProps): React.ReactElement => {
    const ifcNamespace = useSelector(selectIsIfcNamespaceEnabled);
    const editorLocalStorageCommands = `localStorage.setItem('yeself-${guideType}-editor-active', true);\nlocalStorage.setItem('yeself-editor-guideId', '${guideId}');`;

    return (
        <Grid id="yeself-guide-plugin-configuration" container>
            <Grid item xs={12}>
                <Typography gutterBottom variant="subtitle1">
                    <FormattedMessage id="Guides.pluginConfiguration" />
                </Typography>
                <Typography gutterBottom paragraph variant="body1">
                    <FormattedMessage id="Guides.message2" />
                </Typography>
            </Grid>
            <Grid item style={{ overflow: 'auto' }}>
                <Typography variant="body2" gutterBottom>
                    <pre>
                        <code
                            className="language-html"
                            dangerouslySetInnerHTML={{
                                __html: Prism.highlight(
                                    `${editorLocalStorageCommands}\n\n${createYesElfIntegrationScript({
                                        applicationId,
                                        ifcNamespace,
                                        url: EnvironmentConfiguration.AGENT_SCRIPTS_BASE_URL,
                                        baseUrlSlug: EnvironmentConfiguration.SCRIPTS_BASE_SLUG,
                                    })}`,
                                    Prism.languages.javascript
                                ),
                            }}
                        />
                    </pre>
                </Typography>
            </Grid>
        </Grid>
    );
};

export default GuidePluginConfiguration;
